import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "43fcdb2c-43ec-4605-9101-7d9049a83f5e",
  publicId: "25",
  name: "Dispersion, group and phase velocity",
  difficulty: 3,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, principle02, principle03, task01],
};

export default lesson;
